module.exports = __webpack_public_path__ + "static/media/14.b85d047d.png";